module.exports = __webpack_public_path__ + "static/img/why-sales.7ab2283.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/why-sales.svg
// module id = F3DB
// module chunks = 1